module.exports = __webpack_public_path__ + "static/media/photo39.f51f7df2.jpg";